import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Head from "components/head";
import Aside from "components/aside";
import Crumb from "components/crumb";
import { setComRefsAction } from "store/action";
import styles from "./index.less";
import "styles/init.css";

const Layout: React.FC<{
  pageComponent: Function;
}> = ({ pageComponent }) => {
  const dispatch = useDispatch();
  const comRefs = useSelector<any, any>((state) => state.comRefs);
  const crumbRef = useRef<HTMLDivElement>(null);
  const headRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    // 支持head crumb等子组件异步EFFECT
    setTimeout(() => {
      dispatch(
        setComRefsAction({
          ...comRefs,
          crumbRef,
          headRef,
        })
      );
    }, 0);
  }, []);

  return <div className={styles.layout}>
    <Head />
    {pageComponent()}
  </div>;
};

export default Layout;
